<template>
    <div class="rates-detail-container">
        <typo name="body-14-normal" v-if="rates.minimumRateValue">
            Taux minimum : {{ rates.minimumRateValue }}
            {{ getOptionLabel(rates.minimumRateUnit) }}
        </typo>
        <div class="rates-detail-item" v-for="rate in rates.rates" :key="rate._uid">
            <typo name="body-14-normal" v-if="rate.value">
                Taux :{{ rate.value }}
                {{ getOptionLabel(rate.unit) }}
            </typo>
            <typo name="body-14-normal" v-if="rate.salaryBase">
                Assiete : {{ getOptionLabel(rate.salaryBase) }}
            </typo>
            <typo name="body-14-normal" v-if="rate.insuredEntity">
                Assuré : {{ getOptionLabel(rate.insuredEntity) }}
            </typo>
        </div>
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["rates", "annotationOptions"],
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "");
        },
    },
};
</script>

<style scoped lang="sass">
.rates-detail-container
    display: flex
    flex-direction: column
    width: 250px
    margin: 0 16px
    padding: 0 16px
.rates-detail-item
    display: flex
    flex-direction: column
    margin: 8px 0
</style>
